import styled from 'styled-components';

const ErrorViewContent = styled.div`
  text-align: center;
`;

export { ErrorViewContent };
